module.exports = __webpack_public_path__ + "media/images/european-festival-5fcb926f038d4630e6d4a27e6b84d0b3.png";